import * as React from "react";
export var ActivationCode = function (props) {
    return props.activationCode ? (React.createElement(React.Fragment, null,
        props.activationCode.substr(0, props.activationCode.length / 2),
        " ",
        props.activationCode.substr(props.activationCode.length / 2))) : null;
};
//# sourceMappingURL=ActivationCode.js.map